import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';

import {NodeService,SystemService} from 'ngx-drupal7-services';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
user:any={};
node:any={};
body:any;
private nodeService:NodeService;
private systemService:SystemService;

  constructor(public navCtrl: NavController,nodeService: NodeService,systemService: SystemService) {
this.nodeService=nodeService;
this.systemService=systemService;

this.systemService.connect().subscribe(data => {
      this.user=data.user;
  	     console.log(this.user);
  	    });
    	
this.nodeService.getNodeById(1).subscribe(data => {
    	     this.node=data;
    	     console.log(this.node);
    	     this.body=this.node.body['und'][0].value;
    	    });
	  
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts